import logo_oneascent from "../../../image/logo.svg";

export default {
  colorPrimary: "#009BDE",
  fontFamily: "Inter, sans-serif",

  chart_colors: ["#4986ED", "#004579", "#64C981", "#CCB681", "#00BDC4"],
  chart_gauge__color_primary: "#559CF3",
  chart_gauge__color_empty: "#D7D8D8",
  logo_src: logo_oneascent,
  modal_financial_product_details_header_background: "#E7EBEE",
  page_login_button_submit_background: "#192849",
  proposal_copy_investment_amount: "Initial Investment",
  proposal_copy_length_of_investment: "Length of Investment",
  proposal_header_background:
    "radial-gradient(48.27% 96.25% at 81.47% 36.73%, rgba(101, 199, 244, 0.80) 0%, rgba(229, 242, 249, 0.80) 100%)",
  proposal_header_background_filter: "blur(12px)",
  proposal_header_height: 86,
  proposal_header_padding: "24px 40px",
  sidebar_background: "linear-gradient(180deg, #15284B 0, #086E99 100%)",
  sidebar_icon_color: "#fff",
  sidebar_icon_layout_vertical: true,
  sidebar_menu_item_font_size: "12px",
  sidebar_menu_item_hover_background: "#152A4E",
  sidebar_menu_item_padding: "9px",
  sidebar__width: 100,
  tenant_color_primary: "#009BDE",
};
